import { ProjectCard } from "./project-card";

export const data = [
    {
        id: 1,
        proj: <ProjectCard 
        title="Sales Product Analysis" 
        launch="24 Jan 2023" 
        description={[<p>As with any sales data, understanding the data means a step closer to understanding your customers.</p>, 
                    <p>Looking to track business health? Use visualizations as a tool to enable this.</p>,
                    <p>Looking to grow your business? What insights can be drawn from the data to drive targeted decision?</p>,
                    <p>Moving towards a customer centric business? What products can you recommend based on other customers' purchases to personalize each customer's experience?</p>,
                    <p>This project presents a dynamic UI for purpose of self exploration of insights by anyone.</p>,
                    <p>Guides, insights, explanations of metrics made available in the UI!</p>]}
        link="https://my-datascience-app2.herokuapp.com/Sales_Product_Analysis" />
    },
    {
        id: 2,
        proj: <ProjectCard 
        title="Online Retail Analysis" 
        launch="27 Oct 2022" 
        description={[<p>Looking to sensemake your data and profile your customers better? Which business wouldn't love to?</p>, 
                    <p>Enrich existing data with additional data sources to draw richer insights? Why not?</p>,
                    <p>Segment customers to drive more impactful marketing decisions? A win for your business!</p>,
                    <p>This project presents a dynamic UI for purpose of self exploration of insights by anyone.</p>,
                    <p>Guides, insights, explanations of metrics and recommendations made available in the UI!</p>]}
        link="https://my-datascience-app.herokuapp.com/Online_Retail_Analysis" />
    },
    {
        id: 3,
        proj: <ProjectCard 
        title="Data Labeling Platform" 
        launch="30 Sep 2022" 
        description={[<p>Looking to evaluate algorithms or fine-tune models?
                Been labeling data on shared excel files? 
                Or sending files via communication channels and getting confused who has completed their labeling? 
                Can data labeling be done better?</p>,
                <p>A common platform to perform data labeling? Wave goodbye to messy excel files!
                Ingest users' labeling activities directly into a database? Use this data to draw immediate insights and make targeted actions, all on the same platform!
                Sufficient labeled data? Time to evaluate your models/algorithms! Growing labeling conflicts? Time to refine label definitions.</p>,
                <p>As a demo, 100 COVID-19 related text snippets in various languages were obtained. And fasttext's language identification model was used to predict the language of these text snippets.
                Proxy users are introduced on the platform to enable visitors to explore various features on this platform.</p>,
                <p>Guides, details and comments embedded in the UI.</p>]}
        link="https://my-datascience-app.herokuapp.com/Data_Labeling_Platform" />
    },
    {
        id: 4,
        proj: <ProjectCard 
        title="Kpop Analysis" 
        launch="05 Sep 2022"
        description={[<p>Dive into the world of kpop!</p>,
                      <p>A refreshed UI that brings you visualizations of debut frequency over time, correlation between group size and years since debut and population pyramid of idols!</p>,
                      <p>Don't know which companies you're interested in? Get recommendations as starting points by exploring combinations of various metrics, before diving into the visualizations.</p>,
                      <p>Lost on how to use and interpret the visualizations? Guides and insights to your rescue! Simply toggle them on and off in the UI with ease.</p>,
                      <p>Filters and tooltips? A bonus for interactivity.</p>]} 
        link="https://my-datascience-app.herokuapp.com/Kpop_Analysis" />
    },
    {
        id: 5,
        proj: <ProjectCard 
        title="RegEx Away!" 
        launch="09 Aug 2022" 
        description={[<p>Put your regular expression knowledge to test!</p>,
                      <p>This project attempts to use regular expression to extract location information from 2,409 log files and generate a plot using these information.</p>,
                      <p>Adapted from a challenge that I created for an outreach event* in May 2022. Storyline of challenge masked.</p>,
                      <p>Adapted from a challenge that I created for an outreach event* in May 2022. Storyline of challenge masked.<br /><i>* Cyberthon is a joint collaboration between CSIT, DCO and HCI for JC students.</i></p>]}
        link="https://my-datascience-app.herokuapp.com/RegEx_Away" />
    },
    {
        id: 6,
        proj: <ProjectCard 
        title="Stack Overflow Analysis" 
        launch="04 Aug 2022" 
        description={[<p>"How to..." Looking for online help to troubleshoot technical problems? High chance your best friend Google returns at least one result from Stack Overflow.</p>,
        <p>What topics do users ask? How frequent do these topics get asked? Can we observe any behavioural patterns on posted questions and answers?</p>,
        <p>This project aims to answer these.</p>]}
        link="https://my-datascience-app.herokuapp.com/Stack_Overflow_Analysis" />
    },
    {
        id: 7,
        proj: <ProjectCard 
        title="BTS Lyrics" 
        launch="28 Jul 2022" 
        description={[<p>Ever felt like listening to songs with lyrics that convey an emotion you're feeling?</p>,
        <p>This project attempts to use zero-shot classification to assign probability of pre-defined emotions for 230 BTS song lyrics. Input a pre-defined emotion and songs with descending probability of this emotion are returned.</p>,
        <p>Pre-defined emotions used are: happy, confident, sad, fearful, angry, nervous.</p>,
        <p>To provide more flexibility, the input emotion need not be from the pre-defined list. Zero-shot classification can be used to classify this input emotion as a pre-defined emotion and the returned songs follow.</p>]}
        link="https://my-datascience-app.herokuapp.com/BTS_lyrics" />
    },
    {
        id: 8,
        proj: <ProjectCard 
        title="Tableau Site Discovery" 
        launch="09 May 2022" 
        description={[<p>Tableau Site is an analytics space for users to publish their dashboards and share insights.</p>,
        <p>But...users have access to only contents that they are granted permissions to by content owners. This means that they would not be aware of potentially similar contents present on this site. This also means that they would not know who to look for if they wish to request access to a desired content.</p>,
        <p>By tapping on metadata drawn from the Tableau site and presenting them in an interactive UI, it enables creators to identify opportunities for collaborations and users to direct their access requests to content owners with certainty.</p>,
        <p>Data obtained from my personal Tableau Online site.</p>]}
        link="https://my-datascience-app.herokuapp.com/Tableau_Site_Discovery" />
    }
]
